"use client";
import { createContext, useContext } from "react";
const DialogModeContext = createContext('dialog');
const useDialogMode = ()=>useContext(DialogModeContext);
export { DialogModeContext, useDialogMode };
